import React from "react";
import upperFirst from "mn-utils/upperFirst";
import {TableItemWithSubtitle} from "../../../../helpers/Display";
import {Box} from "@material-ui/core";

import {
  DisplayAmountFCMerchant,
  DisplayDataMerchant,
  DisplayDateTimeMerchant,
  DisplayIdMerchant
} from "../../../../helpers/Display/DataDisplay";


export const columnsList = [
  {
    minWidth: 300,
    label: 'Transaction type',
    dataKey: 'transactionKind',
    dataHandler: ({transactionKind = '', email}) => (
      <Box width="100%" pl="4.6rem">
        <TableItemWithSubtitle
          item={(
            upperFirst(transactionKind || '')
                .replace('_', ' ')
          )}
          subItem={email && (
            <DisplayDataMerchant>
              {email}
            </DisplayDataMerchant>
          )}
          alignLeft
        />
      </Box>
    )
  },
  {
    minWidth: 250,
    label: 'Order ID',
    dataKey: 'orderId',
    dataHandler: ({orderId = '', desc = ''}) => (
      <Box width="100%">
        <TableItemWithSubtitle
          item={(
            <DisplayIdMerchant>
              {orderId}
            </DisplayIdMerchant>
          )}
          subItem={desc && (
            <DisplayDataMerchant>
              {desc}
            </DisplayDataMerchant>
          )}
        />
      </Box>
    )
  },
  {
    minWidth: 250,
    label: 'Payment ID',
    dataKey: 'paymentId',
    dataHandler: ({paymentId = ''}) => (
      <DisplayIdMerchant>
        {paymentId}
      </DisplayIdMerchant>
    )
  },
  {
    minWidth: 150,
    label: 'Date',
    dataKey: 'date',
    dataHandler: ({date}) => (
      <DisplayDateTimeMerchant
        date={date}
      />
    )
  },
  {
    minWidth: 150,
    label: 'Amount',
    dataKey: 'amount',
    dataHandler: (row) => {
      const {
        currencyAmount,
        currencyCode,
        cryptoCurrencyAmount,
        cryptoCurrencyCode,
      } = row;

      return (
        <div>
          <DisplayAmountFCMerchant
            fiat={{amount: currencyAmount, symbol: currencyCode}}
            crypto={cryptoCurrencyAmount && {
              amount: cryptoCurrencyAmount,
              symbol: cryptoCurrencyCode,
            }}
          />
        </div>
      )
    }
  },
  {
    minWidth: 175,
    label: 'Status',
    dataKey: 'status',
    dataHandler: ({status = ''}) => (
      <div
        className={`f12 lh lts0em c0 cFFBF43.pending c2CE889.completed
                c9C8FFF.requested cEE4F4F.failed c5B47FF.sent c2.cancelled cC4C4C4.expired ` + status}
      >
        {upperFirst(status)}
      </div>
    )
  },
];
